import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//

import React from "react";
import IconButton from "@material-ui/core/IconButton";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Popover from "@material-ui/core/Popover";
import Tooltip from "@material-ui/core/Tooltip";
import Divider from "@material-ui/core/Divider";
import PeopleIcon from "@material-ui/icons/People";
import { Redirect } from "react-router-dom";
import * as SessionInfo from "../../SessionInfo";
import * as Utils from "../../Utils";
import ManageUsersDialog from "../../configuration/dialog/ManageUsersDialog";
var styles = function styles(theme) {
  return {
    iconButtonAvatar: {
      padding: 2
    }
  };
};
var AccountButton = function AccountButton(_ref) {
  var classes = _ref.classes,
    buttons = _ref.buttons;
  var _React$useState = React.useState(SessionInfo.getUsername()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    username = _React$useState2[0],
    setUserName = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    accountDetailsAnchor = _React$useState4[0],
    setAccountDetailsAnchor = _React$useState4[1];
  var handleLogout = function handleLogout() {
    var clearSessionInfo = function clearSessionInfo() {
      setUserName(null);
      SessionInfo.clear();
    };
    Utils.fetchData("application/auth/logout", {
      method: "post"
    }, false, false).then(clearSessionInfo);
  };
  if (!username) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/login"
    });
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Account"
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    className: classes.iconButtonAvatar,
    onClick: function onClick(event) {
      return setAccountDetailsAnchor(event.currentTarget);
    }
  }, /*#__PURE__*/React.createElement(AccountCircle, null))), /*#__PURE__*/React.createElement(Popover, {
    disableScrollLock: true,
    open: accountDetailsAnchor !== null,
    anchorEl: accountDetailsAnchor,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: function onClickAway() {
      return setAccountDetailsAnchor(null);
    }
  }, /*#__PURE__*/React.createElement(Card, {
    elevation: 2
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, username)
  }), buttons && buttons.map(function (button, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(Divider, {
      light: true
    }), button);
  }), /*#__PURE__*/React.createElement(Divider, {
    light: true,
    variant: "middle"
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: handleLogout,
    style: {
      width: "100%"
    }
  }, "Logout"), /*#__PURE__*/React.createElement(Divider, {
    light: true,
    variant: "middle"
  })))));
};
export default withStyles(styles)(AccountButton);